module.exports = __webpack_public_path__ + "static/media/logo-green.e3ef78f1.svg";